import React, {useEffect, useState} from "react";
import FieldErrorMessage from "../../Utils/FieldErrorMessage";
import {MdDeleteOutline} from "react-icons/md";
import {FaRegEdit} from "react-icons/fa";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import axios from "axios";
import {axiosConfig, isAdmin, translateToBanglaDigit, url} from "../../../helpers/helpers";
import {toast} from "react-toastify";
import Pagination from "../../Utils/Pagination";
import Select2Wrapper from "../../Utils/Select2Wrapper";

const Organization = (
    {
        handleSubmit,
        onSubmit,
        errors,
        register,
        setValue,
        data,
        watch,
        currentPage,
        totalPages,
        setCurrentPage,
        from,
        usrList,
        getUserList,
        getMinistryOrganizationAndInstitution,
        parents,
        handleDelete,
        handleEdit,
        setData,
        permissions,
        listLoading = false,
        saving = false,
    }) => {
    const actionLoading = listLoading || saving;

    const onDragEnd = e => {
        if (!e.destination) {
            return;
        }
        const sorted = reorder(data, e.source.index, e.destination.index);
        setData(sorted)
    };

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const scrollToFormTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    const handleOrganizationEdit = (ministry) => {
        handleEdit(ministry);
        scrollToFormTop();
    }

    const handleSort = () => {
        if (actionLoading) return;

        axios.post(url(`organization-sort`), data, axiosConfig())
            .then((response) => {
                toast.success('Sorted Successful');
            })
            .catch(error => {
                console.log(error);
            });
    }

    const totalEmployeeData = (organizations=[], property=null) => {
        return organizations.reduce((total, org) => total + (parseInt(org[property]) > 0 ? parseInt(org[property]) : 0) , 0);
    }

    useEffect(() => {
        setValue('type', 'organization');
    }, [])

    const [filteredParents, setFilteredParents] = useState(parents);
    const selectedMinistryType = watch('ministry_type');
    const selectedParentId = watch('parent_id');
    const selectedHeadOfOrganization = watch('head_of_organization');
    const [selectedMinistrySearch, setSelectedMinistrySearch] = useState('');
    const parentField = register('parent_id');
    const userOptions = usrList?.map(user => {
        const name = user?.name?.trim();
        return {
            value: user.id,
            label: name ? `${name} (${user.unique_id})` : user.unique_id,
        };
    }) || [];
    const handleChange = (value) => {
        setSelectedMinistrySearch(value);
    }

    const handleParentChange = (event) => {
        parentField.onChange(event);
        setValue('head_of_organization', '');
        getUserList({ministry_id: event.target.value});
    }

    useEffect(() => {
        if (selectedMinistrySearch) {
            getMinistryOrganizationAndInstitution('organization', '', selectedMinistrySearch);
        }

    }, [selectedMinistrySearch, currentPage]);

    useEffect(() => {
        if (selectedMinistryType) {
            const filteredMinistryType = parents.filter(parent => parent.ministry_type === parseInt(selectedMinistryType));
            setFilteredParents(filteredMinistryType);
        } else {
            setFilteredParents(parents);
        }
    }, [selectedMinistryType, parents]);

    return (
        <>
            <div className='card shadow border-0 mt-2'>
                <div className='card-body'>
                    <div className="row">
                        <div className="col-4">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <fieldset disabled={actionLoading}>
                                <div className="row">
                                    <div className="col-12">
                                        <label htmlFor="ministry" className="form-label">মন্ত্রণালয়ের ধরন<span
                                            className='text-danger'>*</span></label>
                                        <select className="form-select"
                                                aria-label="Default select example" {...register('ministry_type')}>
                                            <option value="">মন্ত্রণালয় নির্বাচন করুন</option>
                                            <option value="1">শিল্প মন্ত্রণালয়</option>
                                            <option value="2">অন্যান্য মন্ত্রণালয়</option>
                                        </select>
                                        <FieldErrorMessage errors={errors} name='ministry_type'/>
                                    </div>
                                    <div className="col-12 mt-2">
                                        <label htmlFor="phone" className="form-label">মন্ত্রণালয় <span
                                            className='text-danger'>*</span></label>
                                        <select className="form-select"
                                                {...parentField}
                                                onChange={handleParentChange}>
                                            <option value="" style={{color: 'gray'}}>নির্বাচন করুন</option>
                                            {
                                                filteredParents && filteredParents.map(parent => {
                                                    return (
                                                        <option key={parent.id} value={parent.id}>{parent.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <FieldErrorMessage errors={errors} name='parent_id'/>
                                    </div>
                                    <div className="col-12 mt-2">
                                        <label htmlFor="phone" className="form-label">নাম <span
                                            className='text-danger'>*</span></label>
                                        <input type="text" className="form-control"
                                               {...register("name")}/>
                                        <FieldErrorMessage errors={errors} name='name'/>
                                    </div>
                                    <div className="col-12 mt-2">
                                        <label htmlFor="phone" className="form-label">অর্ডার</label>
                                        <select className="form-select"
                                                aria-label="Default select example" {...register('order')}>
                                            <option value="">অর্ডার নির্বাচন করুন</option>
                                            <option value="A">A</option>
                                            <option value="B">B</option>
                                            <option value="C">C</option>
                                            <option value="D">D</option>
                                            <option value="E">E</option>
                                            <option value="F">F</option>
                                            <option value="G">G</option>
                                            <option value="H">H</option>
                                            <option value="I">I</option>
                                            <option value="J">J</option>
                                            <option value="K">K</option>
                                            <option value="L">L</option>
                                            <option value="M">M</option>
                                            <option value="N">N</option>
                                            <option value="O">O</option>
                                            <option value="P">P</option>
                                            <option value="Q">Q</option>
                                            <option value="R">R</option>
                                            <option value="S">S</option>
                                            <option value="T">T</option>
                                            <option value="U">U</option>
                                            <option value="V">V</option>
                                            <option value="W">W</option>
                                            <option value="X">X</option>
                                            <option value="Y">Y</option>
                                            <option value="Z">Z</option>
                                        </select>
                                    </div>

                                        <div className="col-12 mt-2">
                                        <label htmlFor="total_employee" className="form-label">অবস্থান <label className='text-danger'>*</label> </label>
                                        <input type="text" className="form-control"
                                               {...register("location")}/>
                                        <FieldErrorMessage errors={errors} name='location'/>
                                    </div>

                                    <div className="col-12 mt-2">
                                        <label htmlFor="phone" className="form-label">প্রতিষ্ঠান প্রধান <span
                                            className='text-danger'>*</span></label>
                                        <Select2Wrapper
                                            key={`head-of-organization-${selectedParentId || 'all'}`}
                                            value={selectedHeadOfOrganization}
                                            placeholder="নির্বাচন করুন"
                                            onChange={(value) => setValue('head_of_organization', value)}
                                            options={userOptions}
                                        />
                                        <FieldErrorMessage errors={errors} name='head_of_organization'/>
                                    </div>
                                </div>
                                <br/>
                                <button className="btn btn-sm btn-success">
                                    {saving && <span className="spinner me-2"></span>}
                                    সংরক্ষণ করুন
                                </button>
                                </fieldset>
                            </form>
                        </div>
                        <div className="col-8">
                            <select className="form-select" disabled={actionLoading} onChange={(e) => handleChange(e.target.value)}>
                                <option value="">মন্ত্রণালয় নির্বাচন করুন</option>
                                <option value="1">শিল্প মন্ত্রণালয়</option>
                                <option value="2">অন্যান্য মন্ত্রণালয়</option>

                            </select>
                            <div className='table-responsive pt-4'>
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <Droppable droppableId="Table">
                                        {provided => (
                                            <table
                                                className="table table-bordered table-hover" {...provided.droppableProps}
                                                ref={provided.innerRef}>
                                                <thead>
                                                <tr style={{backgroundColor: '#f9f9f9'}}>
                                                    <th scope="col" style={{textAlign: 'center'}}>ক্রমিক নং</th>
                                                    <th scope="col">নাম</th>
                                                    <th scope="col">মন্ত্রণালয়</th>
                                                    <th className="text-center" scope="col">এন্ট্রিকৃত ডাটা</th>
                                                    <th scope="col">অবস্থান</th>
                                                    <th scope="col">প্রধানের নাম</th>
                                                    <th scope="col">মোবাইল</th>
                                                    <th scope="col">ইমেইল</th>
                                                    <th className="text-center" scope="col">অর্ডার</th>
                                                    <th scope="col">
                                                        অ্যাকশন
                                                        <button className="btn btn-sm btn-primary float-end"
                                                                disabled={actionLoading}
                                                                onClick={handleSort}>
                                                            Sort
                                                        </button>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {listLoading && (
                                                    <tr>
                                                        <td colSpan={10} className="text-center py-5">
                                                            <span className="spinner"></span>
                                                        </td>
                                                    </tr>
                                                )}
                                                {
                                                    !listLoading && data && data.map((ministry, index) => {
                                                        return (
                                                            <Draggable
                                                                key={String(ministry.id)}
                                                                draggableId={String(ministry.id)}
                                                                index={index}>
                                                                {(provided) => (
                                                                    <tr ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                    >
                                                                        <td style={{textAlign: 'center'}}>{translateToBanglaDigit(index + from)}</td>
                                                                        <td>{ministry.name}</td>
                                                                        <td>{ministry.parent?.name}</td>
                                                                        <td className="text-center">{translateToBanglaDigit(ministry?.org_employees_count)}</td>
                                                                        <td>{ministry?.location}</td>
                                                                        <td>{ministry?.organization_head?.name}</td>
                                                                        <td>{ministry?.organization_head?.phone}</td>
                                                                        <td>{ministry?.organization_head?.email}</td>
                                                                       
                                                                        <td className="text-center">{ministry.order}</td>
                                                                        <td>
                                                                            <div>
                                                                                {
                                                                                    (isAdmin() || permissions?.includes('edit')) &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-secondary"
                                                                                        disabled={actionLoading}
                                                                                        onClick={() => handleOrganizationEdit(ministry)}>
                                                                                        <FaRegEdit/>
                                                                                    </button>
                                                                                }
                                                                                {/* &nbsp;
                                                                                {
                                                                                    (isAdmin() || permissions?.includes('delete')) &&
                                                                                    <button className="btn btn-sm btn-secondary"
                                                                                            onClick={() => handleDelete(ministry.id)}>
                                                                                        <MdDeleteOutline/>
                                                                                    </button>
                                                                                } */}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </Draggable>
                                                        )
                                                    })
                                                }
                                                {provided.placeholder}
                                                {!listLoading && (
                                                    <tr>
                                                        <td style={ {textAlign:'right'}} colSpan={3}>মোট</td>
                                                        <td style={{textAlign: 'center'}}>{ translateToBanglaDigit(totalEmployeeData(data, 'org_employees_count')) }</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                                <br></br>
                                <Pagination currentPage={currentPage} totalPages={totalPages}
                                            onPageChange={setCurrentPage}
                                            disabled={actionLoading}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Organization;
